import api from '@/services/api';

const state = {items: [], totalCount: 0};
const getters = {
    getCartItems: state => state.items,
    getCartCount: state => state.items.length,
    getTotalAmount: state => {
        return state.items.reduce((sum, item) => sum + item.unitPrice * item.quantity, 0);
    }
};
const mutations = {
    SET_CART_ITEMS(state, items) {
        state.items = items;
        state.totalCount = items.length;
    }, ADD_CART_ITEM(state, item) {
        const existing = state.items.find(i => i.id === item.id);
        if (existing) {
            existing.quantity += item.quantity;
        } else {
            state.items.push(item);
        }
        state.totalCount = state.items.length;
    }, REMOVE_CART_ITEM(state, itemId) {
        state.items = state.items.filter(item => item.id !== itemId);
        state.totalCount = state.items.length;
    }, UPDATE_CART_ITEM(state, {itemId, quantity}) {
        const item = state.items.find(i => i.id === itemId);
        if (item) {
            item.quantity = quantity;
        }
    }, CLEAR_CART(state) {
        state.items = [];
        state.totalCount = 0;
    }
};
const actions = {
    async getCart({commit}) {
        try {
            const response = await api.get('/cart');
            commit('SET_CART_ITEMS', response.data);
            return response.data;
        } catch (error) {
            console.error('获取购物车失败:', error);
            throw error;
        }
    }, async addToCart({commit}, item) {
        try {
            const response = await api.post('/cart', item);
            commit('ADD_CART_ITEM', response.data);
            return response.data;
        } catch (error) {
            console.error('添加到购物车失败:', error);
            throw error;
        }
    }, async updateCartItem({commit}, {itemId, quantity}) {
        try {
            await api.put(`/cart/${itemId}`, {quantity});
            commit('UPDATE_CART_ITEM', {itemId, quantity});
        } catch (error) {
            console.error('更新购物车失败:', error);
            throw error;
        }
    }, async removeCartItem({commit}, itemId) {
        try {
            await api.delete(`/cart/${itemId}`);
            commit('REMOVE_CART_ITEM', itemId);
        } catch (error) {
            console.error('删除购物车商品失败:', error);
            throw error;
        }
    }, async createOrderFromCart({commit}, items) {
        try {
            const response = await api.post('/purchase-order/from-cart', {items});
            commit('CLEAR_CART');
            return response.data;
        } catch (error) {
            console.error('创建订单失败:', error);
            throw error;
        }
    }
};
export default {namespaced: true, state, getters, mutations, actions};